import React from 'react';
import { Typography } from "@material-ui/core";

export const PanelDatosGenerales = ({ datosDelTramite, atributos = [] }) => {

    if (!datosDelTramite) return null;

    return (
        /* Aumentamos levemente el espacio vertical entre bloques de space-y-2 a space-y-3.5 
           para que cuando no haya cajas grises, respire la interfaz */
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm space-y-3.5 h-full antialiased">
            {
                atributos.map((atributo, index) => {
                    
                    const valorRenderizado = typeof atributo.valor === 'function' 
                        ? atributo.valor() 
                        : atributo.valor;

                    const esString = typeof valorRenderizado === 'string';

                    return (
                        <div key={index} className="w-full">
                            {
                                esString ? (
                                    /* 1. Mapeo de filas estándar (Clave - Valor) */
                                    <div className={`flex items-center justify-between gap-4 py-1.5 text-sm ${
                                        index < atributos.length - 1 ? 'border-b border-slate-100' : ''
                                    }`}>
                                        {/* Etiqueta a la izquierda */}
                                        <span className="text-slate-500 font-medium text-xs sm:text-sm">
                                            {atributo?.descripcion}
                                        </span>
                                        
                                        {/* Valor destacado a la derecha */}
                                        <span className="font-bold text-slate-800 text-right max-w-[65%] truncate">
                                            {valorRenderizado}
                                        </span>
                                    </div>
                                ) : (
                                    /* 2. Mapeo de componentes complejos (Tablas, ColumnasDinamicas, etc.) */
                                    <div className="w-full flex flex-col">
                                        {/* El título superior solo aparece si explícitamente se define una descripción */}
                                        {atributo?.descripcion && (
                                            <span className="text-[10px] font-bold text-slate-400 block uppercase tracking-wider mb-1.5 select-none">
                                                {atributo?.descripcion}
                                            </span>
                                        )}
                                        {/* Contenedor del componente hijo */}
                                        <div className="w-full">
                                            {valorRenderizado}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    );
                })
            }
        </div>
    );
};